import React, { useRef, useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Services from '../components/Services';
import DetailedServices from '../components/DetailedServices';
import TargetAudience from '../components/TargetAudience';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import WelcomePage from '../components/WelcomePage';
import NewsletterPopup from '../components/NewsletterPopup';

const Home = () => {
  const contactRef = useRef(null);
  const [showWelcome, setShowWelcome] = useState(true);
  const [showNewsletter, setShowNewsletter] = useState(false);
  
  useEffect(() => {
    // Show newsletter popup 5 seconds after entering site (after welcome page)
    if (!showWelcome) {
      const timer = setTimeout(() => {
        setShowNewsletter(true);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [showWelcome, setShowNewsletter]);
  
  const scrollToContact = () => {
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  const handleEnterSite = () => {
    setShowWelcome(false);
  };
  
  return (
    <div className="min-h-screen">
      {showWelcome && <WelcomePage onEnter={handleEnterSite} />}
      <NewsletterPopup isOpen={showNewsletter} onClose={() => setShowNewsletter(false)} />
      <Header onContactClick={scrollToContact} />
      <Hero onContactClick={scrollToContact} />
      <Services onContactClick={scrollToContact} />
      <DetailedServices onContactClick={scrollToContact} />
      <TargetAudience />
      <WhyChooseUs />
      <Testimonials />
      <ContactForm />
      <Footer />
    </div>
  );
};

export default Home;
